import { carouselData } from '@/mocks/homeData';

export default function CarouselSection() {
  return (
    <section id="carousel" className="py-14 md:py-20 bg-background-100">
      <div className="w-full px-4 md:px-6">
        <div className="max-w-6xl mx-auto">
          <h2 className="font-heading text-2xl md:text-3xl text-foreground-900 text-center mb-3">
            <i className="ri-file-list-3-line text-primary-500 mr-2"></i>
            焦点专题报道
          </h2>
          <p className="text-sm text-foreground-600 text-center mb-10">
            深度整理热门事件，吃瓜就要吃透
          </p>
          <div className="grid grid-cols-1 lg:grid-cols-5 gap-4">
            {carouselData.map((item) => (
              <div
                key={item.id}
                className="group bg-background-50 rounded-lg overflow-hidden cursor-pointer transition-all hover:translate-y-[-2px] flex flex-col"
              >
                <div className="relative aspect-[2/1] overflow-hidden">
                  <img
                    src={item.image}
                    alt={item.title}
                    className="w-full h-full object-cover object-top transition-transform group-hover:scale-105"
                  />
                  <div className="absolute inset-0 bg-gradient-to-t from-black/40 to-transparent"></div>
                  <span className="absolute top-3 left-3 px-2 py-0.5 rounded bg-primary-500 text-background-50 text-xs font-medium whitespace-nowrap">
                    {item.tag}
                  </span>
                </div>
                <div className="p-4 flex-1 flex flex-col">
                  <h3 className="text-sm font-bold text-foreground-800 mb-2 leading-snug">
                    {item.title}
                  </h3>
                  <p className="text-xs text-foreground-600 leading-relaxed mb-3 flex-1">
                    {item.desc}
                  </p>
                  <span className="inline-flex items-center gap-1 text-xs text-primary-600 font-medium whitespace-nowrap group-hover:text-primary-700 transition-colors">
                    {item.label}
                    <i className="ri-arrow-right-line text-xs"></i>
                  </span>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}